
// 自动注册组件文件
const modulesFiles = require.context('./', true, /.vue$/)

const modules = modulesFiles.keys().reduce((modules, path) => {
  const module = modulesFiles(path).default
  const name = module.name
  modules[name] = module
  return modules
}, {})

const install = (Vue, opts = {}) => {
  Object.keys(modules).forEach(name => {
    Vue.component(name, modules[name])
  })
}
// console.log(modules)
export default {
  install,
  ...modules
}
